export const WaitService = {
  delay: (ms: number) => {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
}
